import { AdStorageStatus } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class AdStorageApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async getAdStorageStatus(): Promise<AdStorageStatus> {
    return this.edgeClient.getAdStorage()
  }
}
